import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CompanyService } from '@app/shared/services/company.service';
import { environment } from '@environments/environment';
import {
  IFBCreateReferralPayload,
  IFBReferralResponse,
  IFBTokenInfo,
  IFBCreateReferralManuallyPayload,
  IFBReferralTenantSettings,
  IFBTokenInfoV2
} from '@interfaces';

@Injectable({
  providedIn: 'root'
})
export class ReferralResource {
  private readonly companyService: CompanyService = inject(CompanyService);
  private readonly http: HttpClient = inject(HttpClient);

  private get url(): string {
    return `https://${this.companyService.subdomain}.${environment.REFERRAL_BASE}`;
  }

  getTokenInfo(shareToken: string) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${shareToken}`,
      'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache',
      Expires: '0'
    });
    return this.http.get<IFBTokenInfo>(this.url + '/api/candidate/referralinfo', { headers });
  }

  getTokenInfoV2(shareTokenOrPersonalReferralToken: string) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${shareTokenOrPersonalReferralToken}`,
      'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache',
      Expires: '0'
    });
    return this.http.get<IFBTokenInfoV2>(this.url + '/api/candidate/v2/referralinfo', { headers });
  }

  createReferral(shareToken: string, body: IFBCreateReferralPayload) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${shareToken}`
    });
    return this.http.post<IFBReferralResponse>(this.url + '/api/candidate/referral', body, { headers });
  }

  createReferralManually(body: IFBCreateReferralManuallyPayload) {
    return this.http.post<any>(this.url + '/api/recruiter/manualreferral', body);
  }

  getSettings() {
    return this.http.get<IFBReferralTenantSettings>(`${this.url}/api/talentscout/settings`);
  }

  updateSettings(body: IFBReferralTenantSettings) {
    const url = `${this.url}/api/admin/settings`;
    return this.http.put<void>(url, body);
  }
}
